// extracted by mini-css-extract-plugin
export default {"filterPanel":"notesFilterPanel_filterPanel__r4Ib2"};